<template>
  <div id="output" class="flex h-100 flex-wrap pagebgd" style="overflow: hidden">
    <div @click="back()" class="power">
      <i style="cursor: pointer;" class="el-icon-back"></i>
    </div>
    <div class="etime2">统计起始时间：{{ formatDate(filtersParams['startTime']) }}</div>
    <div class="etime1">统计终点时间：{{ formatDate(filtersParams['endTime']) }}</div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <div class="font-big font-weight light-title">
        {{ title }}
        <template v-if="filtersParams['lineUUID']">{{ lineMap[filtersParams['lineUUID']] }}</template>
        <template v-else>(总产线)</template>
      </div>
    </header>
    <div class="w-100 h-65" style="padding:0px 5px;" id="outputd">
      <div style="text-align:right;widht:100%">
        <el-button @click="openReportTabModal()" size="mini" type="primary" icon="el-icon-film">报告清单</el-button>
        <el-button @click="openFilterModal()" size="mini" type="primary" icon="el-icon-edit">筛选入口</el-button>
      </div>
      <table class="table-wrapper">
        <thead>
          <tr
            style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th rowspan="2" style="width:5%">排序</th>
            <th rowspan="2" style="width:5%" v-if="dayIssue">日期</th>
            <th rowspan="2" style="width:8%">区域</th>
            <th rowspan="2" style="width:10%">设备</th>
            <th rowspan="2" style="width:5%">项目</th>
            <th rowspan="2" style="width:10%">产品</th>
            <th rowspan="2" style="width:25%">问题描述</th>
            <th rowspan="2" style="width:7%">累计时长(分钟)</th>
            <th rowspan="2" style="width:5%">责任部门</th>
            <th rowspan="2" style="width:5%" v-if="filtersParams['lineUUID']">责任人</th>
            <th colspan="2" style="width:15%">问题处理方式</th>
            <th rowspan="2" style="width:5%">重复发生</th>
          </tr>
          <tr
            style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th style="font-weight:100;font-size: 0.15rem;color:white">5WHY，A3，8D</th>
            <th style="font-weight:100;font-size: 0.15rem;color:white">报告状态</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(tr, ind) in leftValue">
            <tr :key="'leftValue-' + ind">
              <td>{{ (ind + 1) }}</td>
              <td v-if="dayIssue">{{ tr.happenDate }}</td>
              <td>{{ tr.line }}</td>
              <td>{{ tr.device }}</td>
              <td>{{ tr.items }}</td>
              <td>{{ tr.productName }}</td>
              <td>{{ tr.faiCause }}</td>
              <td>{{ tr.duration }}</td>
              <td>{{ tr.dept }}</td>
              <td v-if="filtersParams['lineUUID']">{{ tr.owner }}</td>
              <td>
                <template v-if="tr.process != 0">
                  <a href="javascript:void(0);" @click="reportDetails(tr)" style="color:white">
                    {{ processMap[tr.process] }}
                  </a>
                </template>
                <template v-else>
                  {{ processMap[tr.process] }}
                </template>
              </td>
              <td>
                <template v-if="tr.issueStatus">
                  {{ tr.issueStatus == 'G' ? 'Close' : 'Open' }}
                </template>
                <template v-else>
                  <template v-if="tr.process == 0">
                    NA
                  </template>
                  <template v-else>
                    派单中
                  </template>
                </template>
              </td>
              <td> 
                <template v-if="tr.countTol>1">Yes</template>
                <template v-else>No</template>
              </td>
            </tr>
          </template>
          <tr class="tfoot">
            <td colspan="3" style="font-size:0.28rem;">条件周期内OEE 平均值</td>
            <td :style="{ 'font-size': '0.28rem', 'color': (oeeAvg['oee'] >= oeeAvg['oeeKpi']) ? '#00E690' : 'red' }"
              colspan="9">
              {{ oeeAvg['oee'] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="w-100 h-25">
      <div class="w-100 h-100 p-tb" id="deptDiscoveryRateEchart"></div>
    </div>

    <el-dialog title="条件筛选" @close="closeModal()" :close-on-click-modal="false" :visible.sync="dialogFormVisible"
      width="50%">
      <el-form :rules="formRules" ref="form" size="small" :model="form" label-width="120px">
        <el-row :gutter="22">
          <el-col :span="24">
            <el-form-item prop="date" label="日期：">
              <el-date-picker v-model="form.date" style="width:100%" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lineUUID" label="区域：">
              <el-select v-model="form.lineUUID" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in lineList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="device" label="设备名称：">
              <el-select v-model="form.device" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in deviceList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="product" label="产品名称：">
              <el-select v-model="form.product" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in productList" :key="item.uuid" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="item" label="项目名称：">
              <el-select v-model="form.item" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in itemList" :key="item.uuid" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="downType" label="停机类型：">
              <el-select v-model="form.downType" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in downTypeList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="downCode" label="故障代码：">
              <el-select v-model="form.downCode" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in downCodeList" :key="item.uuid" :label="item.faiCode + item.faiCause"
                  :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dept" label="责任部门：">
              <el-select v-model="form.dept" style="width: 100%" clearable filterable placeholder="请选择">
                <el-option v-for="item in deptList" :key="item.uuid" :label="item.title" :value="item.uuid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="quantity" label="累计时长大于：">
              <el-input-number v-model="form.quantity" style="width: 140px" controls-position="right" :precision="0"
                :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="countTol" label="重复次数大于">
              <el-input-number v-model="form.countTol" style="width: 140px" controls-position="right"
                :precision="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="pageSize" label="显示条数：">
              <el-input-number v-model="form.pageSize" style="width: 140px" controls-position="right" :precision="0"
                :min="1"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="9">
            <el-button type="primary" size="small" @click="okFilter()" icon="search" style="margin-left: 18px">
              确认
            </el-button>
            <el-button type="danger" v-if="!form.uuid" size="small" icon="reload" @click="resetForm()"
              style="margin-left: 8px">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../../router";
import format from "date-fns/format";
export default {
  name: "oee-issue-top",
  data() {
    return {
      dayIssue: false,
      statusMap: {
        null: '',
        '1': 'Close',
        '0': 'Open'
      },
      processMap: {
        1: '5WHY',
        2: 'A3',
        3: '8D',
        0: 'NA'
      },
      websock: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "TOP OEE 问题追踪",
      leftValue: [], // 值;
      loading: null,
      now: null,
      week: null,
      updateTimeText: null,
      dialogFormVisible: false,
      oeeAvg: {
        'oee': 0,
        'oeeKpi': 0
      },
      form: {
        date: null,
        pageSize: 20,
        lineUUID: null,
        device: null,
        product: null,
        downCode: null,
        dept: null,
        item: null,
        downType: null,
        quantity: null,
        countTol: null
      },
      filtersParams: {
        pageSize: 20,
        lineUUID: null,
        device: null,
        downCode: null,
        dept: null,
        item: null,
        downType: null,
        startTime: null,
        endTime: null,
        countTol: null,
        quantity: null,
      },
      formRules: {

      },
      userList: [],
      lineList: [],
      lineMap: {},
      productList: [],
      deviceList: [],
      deptList: [],
      itemList: [],
      downTypeList: [],
      downCodeList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近7天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近90天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  mounted() {
    var lineUUID = this.$route.query.line;
    this.filtersParams['lineUUID'] = lineUUID || null;

    // this.onShow();
    this.loadBoardTitle();
    // 初始化
    this.defaultDate();//默认条件
    this.webSocket();
    this.loadData(); //保留http
    this.loadOptions();
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    reportDetails(tr) {
      if (!tr.issueId) {
        return;
      }
      if (tr.process == 1) {
        window.open('https://tiamsapp04.magna.global/kanban/#/fr/5why?key=' + tr.issueId, '_self');
      } else if (tr.process == 2) {
        window.open('https://tiamsapp04.magna.global/kanban/#/fr/a3?key=' + tr.issueId, '_self');
      } else if (tr.process == 3) {
        window.open('https://tiamsapp04.magna.global/kanban/#/fr/8d?key=' + tr.issueId, '_self');
      }
    },
    resetForm() {
      this.form = {
        date: null,
        pageSize: 20,
        lineUUID: null,
        device: null,
        product: null,
        downCode: null,
        dept: null,
        item: null,
        downType: null,
        quantity: null,
        countTol: null
      }
    },
    defaultDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      var end = new Date();
      this.filtersParams['startTime'] = start;
      this.filtersParams['endTime'] = end;
    },
    closeModal() {
      this.dialogFormVisible = false;
    },
    openFilterModal() {
      this.dialogFormVisible = true;
      Object.assign(this.form, this.filtersParams);
      if (this.filtersParams.startTime && this.filtersParams.endTime) {
        this.form['date'] = [this.filtersParams.startTime, this.filtersParams.endTime];
      }
    },
    openReportTabModal() {
      window.open('https://tiamsapp04.magna.global/kanban/#/fr/groups', '_blank');
    },
    okFilter() {
      Object.assign(this.filtersParams, this.form);
      if (this.form['date'] && this.form['date'].length > 0) {
        this.filtersParams['startTime'] = this.form['date'][0];
        this.filtersParams['endTime'] = this.form['date'][1];
      } else {
        this.filtersParams['startTime'] = null;
        this.filtersParams['endTime'] = null;
      }

      if (this.filtersParams['downCode']) {
        this.dayIssue = true;
      } else {
        this.dayIssue = false;
      }

      this.closeModal();
      this.loadData();
    },
    decimal2(num) {
      // 先将数字乘以 10，使用 toFixed 方法将结果保留 0 位小数，再除以 10
      if (num == 0 || num == 100) {
        return num;
      }
      let result = parseFloat((num * 10).toFixed(0)) / 10;
      return result;
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },
    loadOptoData(set) {
      //加载柏拉图
      var lineEchart = this.$echarts.init(
        document.getElementById("deptDiscoveryRateEchart")
      );

      if (this.dayIssue) {
        // 去重复日期累加数量
        let totalQuantitiesByItem = set.reduce((accumulator, transaction) => {
          accumulator[transaction.happenDate] = (accumulator[transaction.happenDate] || 0) + transaction.duration;
          return accumulator;
        }, {});
        var itemSet = [];
        for (let key in totalQuantitiesByItem) {
          if (totalQuantitiesByItem.hasOwnProperty(key)) { // 确保属性是对象自身的而不是从原型链继承的
            itemSet.push({ 'happenDate': key, 'duration': totalQuantitiesByItem[key], 'collectTotal': set[0]['collectTotal'] });
          }
        }
        set = itemSet;
      }

      var total = 0;
      for (var i = 0; i < set.length; i++) {
        var quantity = set[i].duration;
        total += quantity;
      }

      var fold = 0;
      for (var i = 0; i < set.length; i++) {
        var quantity = set[i].duration;
        fold += quantity;
        var probability = 0;
        var proportion = 0;
        if (this.dayIssue) {
          var totalMap = set[i]['collectTotal'];
          var happenDate = set[i]['happenDate'];
          var worKingHours = totalMap[happenDate]['worKingHours'];
          if (quantity > 0 && worKingHours > 0) {
            probability = parseFloat(((quantity / worKingHours) * 100)).toFixed(2);
          }
        } else {
          if (fold != 0) {
            probability = (parseInt(((fold / total) * 100) + '', 0));
            proportion = (parseInt(((quantity / total) * 100) + '', 0));
          }
        }

        set[i]['proportion'] = proportion;
        set[i]['probability'] = probability;
      }

      const xAxis = [];
      const lineData = [];
      const barData = [];
      set.forEach(item => {
        barData.push(item.duration);
        if (this.dayIssue) {
          xAxis.push(item.happenDate);
        } else {
          xAxis.push(item.faiCause);
        }
        lineData.push(item.probability);
      })

      var chartOption = {
        grid: {
          top: 35,
          bottom: 25,
          x: 40,
          y: 50,
          left: 50,
          right: 50,
        },
        legend: {
          data: ['时长', "百分比"],
          show:false,
          textStyle: {
            color: "#fff",
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
                fontSize: 13,
              },
              formatter: function (value) {
                if (value.length > 6) {
                  return `${value.slice(0, 8)}...`;
                }
                return value;
              },
            },
            data: xAxis,
            nameTextStyle: {
              color: "#ffffff",
            },
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '时长',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: false, //隐藏
            },
          },
          {
            type: 'value',
            name: '百分比',
            min: 0,
            scale: true,
            axisLabel: {
              formatter: '{value} %'
            },
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: false, //隐藏
            },
          }
        ],
        series: [
          {
            color: ['#1E4788'],
            name: '时长',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: "50",
            data: barData,
            barGap: '-100%',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: { //数值样式
                    color: '#FFFFFF',
                    fontSize: 14
                  }
                }
              }
            }
          },
          {
            color: ['#FFFFFF'],
            name: '百分比',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: lineData,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: '#FFFFFF',
                    fontSize: 14
                  },
                  formatter: "{c}% ",
                }
              }
            }
          }
        ]
      };
      lineEchart.setOption(chartOption);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });
    },
    loadOptoData2() {
      //加载柏拉图
      var lineEchart = this.$echarts.init(
        document.getElementById("deptDiscoveryRateEchart")
      );


      var maxNum = null;
      var interVal = null;
      const xAxis = ['表面', '孔洞', '毛刺', '停机', '换刀', '设备卡死', '其他'];
      const lineData = [78, 33, 22, 33, 55, 66, 77];
      const lineKpi = [96, 96, 96, 96, 96, 96, 96];

      var option2 = {
        title: {
          text: '柏拉图',
          left: "center",
          textStyle: {
            color: "#ffffff",
            fontSize: "24",
          },
        },
        grid: {
          top: 35,
          bottom: 25,
          x: 40,
          y: 50,
          left: 30,
          right: 20,
        },
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 13,
              },
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            name: "%",
            nameGap: 5,
            type: "value",
            min: 0,
            axisLabel: {
              //  formatter: "{value} %",
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: true, //隐藏
            },
            interval: interVal,
            max: maxNum,
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        label: {
          show: true,
          position: "inside",
          style: {
            fontSize: 10,
          },
          // formatter: (params) => {
          //   return params.value + "%";
          // },
        },
        series: [
          {
            name: "实际",
            type: "bar",
            data: lineData,
            barWidth: 30,
            barGap: "-100%",
            itemStyle: {
              normal: {
                color: function (params) {
                  return "#00E690";
                },
              },
            },
            color: "red",
            markLine: {
              symbol: ["none", "none"], //去掉箭头
              lineStyle: {
                type: "dashed",
                normal: {
                  type: "solid",
                  color: "#00E690 ", // 这儿设置安全基线颜色
                },
              },
              data: [
                {
                  yAxis: 95,
                },
              ],
              label: {
                show: true,
                distance: [-20, 0],
                position: "insideStartBottom",
                color: "#00E690",
              },
            },
          },
        ],
      };

      lineEchart.setOption(option2);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        var params = {};
        Object.assign(params, this.filtersParams);

        if (params['startTime']) {
          delete params['date'];
          params['startTime'] = params['startTime'].setHours(0, 0, 0, 0);
        }
        if (params['endTime']) {
          delete params['date'];
          params['endTime'] = params['endTime'].setHours(23, 59, 59, 0);
        }
        this.startLoading();
        API.oeeIssueTopList(params)
          .then((res) => {
            if (res.success === true) {
              this.format(res);
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },
    loadOptions() {
      //加载配置项列表
      var that = this;
      API.loadOeeProductLine()
        .then((res) => {
          if (res.success === true) {
            this.lineList = res.list;
            var lineMap = {};
            for (var i = 0; i < res.list.length; i++) {
              var data = res.list[i];
              lineMap[data['key']] = data['title'];
            }
            that.lineMap = lineMap;
          }
        }).catch((error) => {
          console.log(error);
        });

      API.loadOeeDevice()
        .then((res) => {
          if (res.success === true) {
            this.deviceList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOeeProduct()
        .then((res) => {
          if (res.success === true) {
            this.productList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOeeItem()
        .then((res) => {
          if (res.success === true) {
            this.itemList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOeeDownCode()
        .then((res) => {
          if (res.success === true) {
            this.downCodeList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOeeDownType()
        .then((res) => {
          if (res.success === true) {
            this.downTypeList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
      API.loadOrgDept()
        .then((res) => {
          if (res.success === true) {
            this.deptList = res.list;
          }
        }).catch((error) => {
          console.log(error);
        });
    },
    //格式化数据
    format(res) {
      var oee = res['OEE'] || 0;
      oee = this.decimal2(oee);
      var oeeKPI = res['OEEKPI'] || 0;
      this.oeeAvg['oee'] = oee;
      this.oeeAvg['oeeKpi'] = oeeKPI;
      //--------------------------
      this.leftValue = [];
      this.leftValue = res.list;
      this.endLoading();
      this.loadOptoData(this.leftValue);//加载柏拉图
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/oee/plan/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/oee/plan/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("OEE socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("OEE socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" OEE socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
.pagebgd {
  background: url("../../../../assets/img/8dbg.png");
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/issue-top/oee-list/board.vue